<template>
  <live-hub-form
    :live-hub-id="emptyGuid"
    @submit="addLiveHub"
    @close="onClose"
  />
</template>
<script>
import LiveHubForm from '../Form.vue'

export default {
  name: 'CreateLiveHub',
  components: {
    LiveHubForm,
  },
  data() {
    return {
      emptyGuid: '00000000-0000-0000-0000-000000000000',
    }
  },
  methods: {
    addLiveHub(liveHub) {
      const query = {
        jobTemplateId: liveHub.jobTemplateId,
        destination: liveHub.destination,
        description: liveHub.description,
        bucket: liveHub.bucket,
        record: liveHub.record,
        input: liveHub.input,
        tags: liveHub.tags,
        playbackAuthorizationEndpoint: liveHub.playbackAuthorizationEndpoint,
        allowedCountries: liveHub.allowedCountries,
        disallowedCountries: liveHub.disallowedCountries,
      }
      this.$store
        .dispatch('liveHubs/createLiveHubV2', query)
        .then(res => {
          this.successToast('Live Hub was added')
          this.onSuccess(res)
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while creating live hub.')
        })
    },
    onSuccess(response) {
      const { name } = response.data.result
      this.$router.push({ name: 'live-hub-settings', params: { liveHubName: name } })
    },
    onClose() {
      this.$router.push({
        name: 'live-hubs',
      })
    },
  },
}
</script>
